module.exports = __webpack_public_path__ + "img/logo.80ea82de.png";